import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useDashboardStore } from '../stores/dashboardStore';
import './ProjectCarousel.css';

const ProjectCarousel: React.FC = () => {
    const { config } = useDashboardStore();
    const [currentIndex, setCurrentIndex] = useState(0);

    const nextSlide = () => {
        setCurrentIndex((prevIndex) =>
            prevIndex === config.projects.length - 1 ? 0 : prevIndex + 1
        );
    };

    const prevSlide = () => {
        setCurrentIndex((prevIndex) =>
            prevIndex === 0 ? config.projects.length - 1 : prevIndex - 1
        );
    };

    const goToSlide = (index: number) => {
        setCurrentIndex(index);
    };

    return (
        <div className="project-carousel">
            <div className="carousel-container">
                <button className="carousel-btn prev" onClick={prevSlide} aria-label="Previous project">
                    ‹
                </button>

                <div className="carousel-content">
                    <div
                        className="carousel-track"
                        style={{ transform: `translateX(-${currentIndex * 100}%)` }}
                    >
                        {config.projects.map((project, index) => (
                            <div key={project.id} className="carousel-slide">
                                <div className="project-card">
                                    <div className="project-image">
                                        <img src={project.image} alt={project.title} />
                                    </div>

                                    <div className="project-info">
                                        <h3 className="project-title">{project.title}</h3>
                                        <p className="project-slogan">{project.slogan}</p>

                                        <div className="project-features">
                                            <h4>主要功能：</h4>
                                            <ul>
                                                {project.features.map((feature, featureIndex) => (
                                                    <li key={featureIndex}>{feature}</li>
                                                ))}
                                            </ul>
                                        </div>


                                        <div className="project-actions">
                                            <Link
                                                to={`/projects/${project.id}`}
                                                className="btn btn-primary"
                                            >
                                                了解更多
                                            </Link>
                                            {project.demoUrl && (
                                                <a
                                                    href={project.demoUrl}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="btn btn-secondary"
                                                >
                                                    查看源码
                                                </a>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                <button className="carousel-btn next" onClick={nextSlide} aria-label="Next project">
                    ›
                </button>
            </div>

            <div className="carousel-indicators">
                {config.projects.map((_, index) => (
                    <button
                        key={index}
                        className={`indicator ${index === currentIndex ? 'active' : ''}`}
                        onClick={() => goToSlide(index)}
                        aria-label={`Go to slide ${index + 1}`}
                    />
                ))}
            </div>
        </div>
    );
};

export default ProjectCarousel;

